// @flow
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  typeIsVideo: ?boolean,
};

export default styled<any, Theme, Props>('div')`
  height: ${({ typeIsVideo }) => (typeIsVideo ? 'auto' : '21.75rem')};
  width: 100%;
  overflow: hidden;
  ${({ typeIsVideo }) => (!typeIsVideo && css`
    display: flex;
    align-items: center;
    justify-content: center;
  `)};
`;
